// src/store/store.js
import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducers"; // Make sure this path is correct

// Persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["chargePoint"], // Specify which reducers you want to persist
};

// Apply the persist reducer to the root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store with middleware and reducer
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
export default store;
